var _path, _path2, _path3, _path4, _g, _path5, _ellipse, _ellipse2, _ellipse3, _path6, _path7, _path8, _path9, _path10, _polygon, _polygon2, _g2, _path11, _path12, _path13, _path14, _path15, _g3, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "550px",
    height: "234px",
    viewBox: "0 0 550 234",
    enableBackground: "new 0 0 550 234",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    fill: "#EEF0F5",
    d: "M208.506,75.69c0,0-16.839,10.531-16.462,24.606c0.377,14.072,14.702,18.821,14.451,26.818 c-0.251,7.996-21.243,30.738-6.223,45.483c15.02,14.743,47.606,1.063,60.214,1.906c12.608,0.842,16.126,17.725,34.222,17.781 c18.094,0.054,23.837-17.438,33.531-34.682c9.694-17.246,42.311,3.496,46.18-18.046c3.872-21.543-11.726-28.7-6.959-45.371 s-6.933-38.53-28.597-47.85c-21.664-9.321-16.446-42.689-46.568-34.191c-30.122,8.498-77.11,5.948-77.927,44.728 C214.079,70.623,208.506,75.69,208.506,75.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    fill: "#E2E6EF",
    d: "M287.46,171.632c-12.438,0.041-14.426-9.409-24.212-12.249 c-8.262-2.397-19.734,3.203-28.465,2.99c-9.323-0.229-18.57-2.537-24.111-10.726c-8.313-12.287,1.527-20.713,2.555-32.225 c0.647-7.244-8.193-12.988-8.445-22.201c-0.339-12.446,8.473-14.522,13.363-23.638c4.462-8.315,2.34-18.502,8.479-26.949 c6.836-9.407,18.278-13.295,29.102-15.995c21.316-5.318,41.979-13.267,56.646,6.507c7.498,10.108,12.816,12.236,22.231,20.484 c13.145,11.514,11.742,21.354,13.322,36.932c2.024,19.964,14.346,43.716-15.57,46.676c-13.123,1.299-11.678-0.311-19.053,11.856 C307.336,162.936,300.025,171.692,287.46,171.632z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.5645,
    y1: 234,
    x2: 286.5645,
    y2: 207.0781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0985,
    style: {
      stopColor: "#F7F8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4121,
    style: {
      stopColor: "#E1E6EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    style: {
      stopColor: "#D4DBE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0D7E6"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    fill: "url(#XMLID_2_)",
    d: "M226.281,211.553c-29.403,10.337-10.538,23.848,35.052,21.54 c45.589-2.309,76.515,6.928,95.059-6.922c18.541-13.851-22.589-19.146-64.804-19.093 C249.375,207.129,238.313,207.324,226.281,211.553z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    fill: "#BFCBEB",
    d: "M282.915,41.74c-33.081,0-49.763,21.087-53.438,47.234 c-3.675,26.146-6.22,33.176-17.529,20.242c-11.31-12.932-15.833,3.655-3.676,16.307c12.158,12.651,16.964,11.527,15.551,30.364 c-1.414,18.837-4.241,37.675,9.896,37.111c14.137-0.562,14.703-14.9,22.619-14.9s8.765,17.456,23.185,14.914 c14.418-2.543,9.419-14.083,21.205-15.757c3.958-0.562,3.676,13.214,20.64,12.37c16.963-0.845,13.006-10.684,18.378-14.338 c5.371-3.655,12.439,6.748,21.487-0.282c9.049-7.027,0.284-12.65,3.678-20.805c3.391-8.154,0-16.87-4.524-16.87 s-8.764,8.716-14.421,7.592c-5.654-1.125-8.479-9.277-8.479-20.805C337.485,112.591,343.986,41.74,282.915,41.74z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_64_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    fill: "#9EAFDD",
    d: "M281.857,73.932c20.396-2.898,32.049-11.143,32.049-11.143l10.59-1.853l-48.205-18.895 c-28.697,2.643-43.392,22.593-46.814,46.933c-0.391,2.781-0.769,5.345-1.146,7.692c1.275-0.595,2.448-1.121,3.326-1.786 c3.81-2.897,11.43-27.268,11.43-27.268S261.464,76.828,281.857,73.932z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    fill: "#9EAFDD",
    d: "M219.397,115.343c-1.973-0.593-4.39-2.627-7.45-6.127 c-11.31-12.932-15.833,3.655-3.676,16.307c2.003,2.086,3.805,3.793,5.414,5.28C215.692,129.123,219.376,124.756,219.397,115.343z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    fill: "#2F3957",
    d: "M256.36,35.158c0,0,0.529-1.123-4.819-8.015c-5.35-6.889-7.969-11.574,1.794-14.88 c9.763-3.308,35.641-19.494,48.032-8.47c12.391,11.024,36.307,20.118,44.067,30.04c7.76,9.921-20.938,27.103-20.938,27.103 l-61.929-14.702L256.36,35.158z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_4_",
    fill: "#65749F",
    cx: 259.023,
    cy: 87.709,
    rx: 5.796,
    ry: 5.763
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_5_",
    fill: "#65749F",
    cx: 292.327,
    cy: 87.709,
    rx: 5.796,
    ry: 5.763
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6_",
    fill: "#65749F",
    cx: 275.28,
    cy: 117.509,
    rx: 4.523,
    ry: 12.513
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    fill: "#2F3957",
    d: "M256.753,43.345c0,0-17.846,4.553-16.519,10.355c1.326,5.803,26.257,17.144,48.299,13.034 c5.747-1.071,16.878-6.963,16.878-6.963L256.753,43.345z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    fill: "#869BD4",
    d: "M309.856,114.174c0,0,6.491,17.449,6.352,27.603c-0.141,10.156,8.394,7.651,10.213,5.426 c1.818-2.227,4.849-10.268,5.362-17.779L309.856,114.174z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    fill: "#BFCBEB",
    d: "M309.856,113.939c0,0,9.747,12.41,9.747,22.567c0,10.155,9.75,7.527,11.608-4.012 c1.854-11.542-1.395-18.555-1.395-18.555H309.856z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    fill: "#232B41",
    d: "M256.36,43.542v-8.384c0,0,10.371,6.999,31.233,11.648 c13.748,3.065,27.913,5.352,35.972,6.556c2.997,0.448,4.413,3.932,2.567,6.325l0,0c-0.826,1.072-2.143,1.652-3.496,1.54 l-17.344-1.456C305.293,59.771,267.741,56.55,256.36,43.542z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    fill: "#232B41",
    d: "M212.227,128.187L212.227,128.187c-1.489,0.239-2.892-0.769-3.131-2.25l-3.812-23.575 l5.396-0.862l3.811,23.575C214.729,126.555,213.717,127.948,212.227,128.187z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_13_",
    fill: "#E5EAF7",
    points: "189.393,107.083 165.242,77.614 178.889,42.104 216.687,36.062 240.838,65.531  227.189,101.04 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_14_",
    fill: "#E54750",
    points: "190.504,104.191 168.32,77.122 180.856,44.504 215.575,38.955 237.759,66.023  225.223,98.641 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9928 -0.1587 0.1596 0.9872 179.1992 87.668)",
    fill: "#E5EAF7",
    fontFamily: "'DINCondensed-Bold'",
    fontSize: 30.6389
  }, "S")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9928 -0.1587 0.1596 0.9872 194.1943 85.2715)",
    fill: "#E5EAF7",
    fontFamily: "'DINCondensed-Bold'",
    fontSize: 30.6389
  }, "T")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9928 -0.1587 0.1596 0.9872 208.4902 82.9863)",
    fill: "#E5EAF7",
    fontFamily: "'DINCondensed-Bold'",
    fontSize: 30.6389
  }, "OP")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    fill: "#6D7FB6",
    d: "M284.885,18.711c0,0,3.264,3.11,6.996,1.619l2.393,2.843c0,0-3.763,3.357-3.433,6.667 c0.331,3.309,2.15,7.8-5.365,8.922c-5.416,0.81-6.198,0.22-6.198,0.22s-4.252-2.979-5.68-5.766 c-1.427-2.786,2.182-5.003,2.274-7.922c0.094-2.919-0.801-5.578-0.801-5.578l2.501-1.797 C277.572,17.919,280.704,20.499,284.885,18.711z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    fill: "#869BD4",
    d: "M273.935,133.927c0,0,6.143,1.423,8.999-3.904c0,0-0.427,5.894-4.498,7.031 C274.363,138.188,273.935,133.927,273.935,133.927z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    fill: "#596179",
    d: "M345.435,33.832c-7.761-9.921-31.677-19.015-44.067-30.039 c-9.144-8.135-25.63-1.453-37.568,3.938c0.01-0.003,22.977-7.445,30.475-2.494c7.498,4.952,34.64,27.731,42.607,30.826 c7.967,3.094-2.454,17.933-2.454,17.934C341.861,48.105,350.023,39.7,345.435,33.832z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    fill: "#D9E0F3",
    d: "M331.783,129.424c0,0-0.163-9.621-1.966-15.04c-1.803-5.419-4.731-9.384-4.731-9.384 S332.111,122.252,331.783,129.424z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    fill: "#D9E0F3",
    d: "M365.412,142.102l-0.274-0.681c-1.078-2.479-2.81-4.09-4.752-4.09 c-4.524,0-8.764,8.716-14.421,7.592c-5.654-1.125-8.479-9.277-8.479-20.805c0-7.076,2.446-36.5-9.784-58.175l-3.205-5.008 c0,0,10.187,18.321,10.187,37.553c0,19.23-4.038,48.805,8.288,50.711S357.674,134.363,365.412,142.102z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_71_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    fill: "#9EAFDD",
    d: "M339.745,175.288c5.371-3.655,12.593,6.748,21.642-0.282 c4.508-3.502,4.734-6.656,4.117-9.948l0,0c-1.23,6.929-9.042,7.706-18.175,4.93c-9.133-2.774-12.763,1.767-15.469,10.098 c-2.707,8.331-17.12,2.264-26.254-4.013c-9.132-6.273-10.927,0.727-21.92,6.22c-10.994,5.494-13.626-6.754-24.653-8.985 c-11.028-2.228-18.406,12.574-27.793,11.816c-6.864-0.552-7.532-19.422-7.396-29.525c-0.007,0.098-0.014,0.191-0.021,0.29 c-1.414,18.837-4.241,37.675,9.896,37.111c14.137-0.562,14.703-14.9,22.619-14.9c7.917,0,8.765,17.456,23.185,14.914 c14.418-2.543,9.419-14.083,21.205-15.757c3.958-0.562,3.676,13.214,20.64,12.37C338.33,188.781,334.373,178.942,339.745,175.288z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_74_",
    fill: "#9EAFDD",
    points: "224.052,149.354 224.052,149.354 224.052,149.354  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_233_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.1079,
    y1: 22.7622,
    x2: 87.1079,
    y2: 211.2378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1E5EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2371,
    style: {
      stopColor: "#D4DBE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#D0D7E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6CDDB"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_237_",
    fill: "url(#XMLID_7_)",
    d: "M99.744,174.88H8.604L0,138.255L97.593,22.762h52.695v113.354h23.928v38.764 h-23.928v36.357H99.744V174.88z M99.744,136.382V82.647l-44.899,53.734H99.744z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.8916,
    y1: 22.7622,
    x2: 462.8916,
    y2: 211.2378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1E5EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2371,
    style: {
      stopColor: "#D4DBE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#D0D7E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6CDDB"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_234_",
    fill: "url(#XMLID_16_)",
    d: "M475.528,174.88h-91.141l-8.604-36.625l97.595-115.493h52.695v113.354H550v38.764 h-23.927v36.357h-50.545V174.88z M475.528,136.382V82.647l-44.897,53.734H475.528z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.dd24f1f1969d15ac02d49404c9048e6b.svg";
export { ForwardRef as ReactComponent };